<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p28"><span><a href="#/Contents#rp28">CONFETTI SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="22" src="images/45.jpg" width="22"/></span></p>
<p class="normal"><span><i>A no-time-to-cook soup that can be made in minutes, using frozen broccoli and cauliflower.</i></span></p>
<p class="make"><span>8 first-course servings</span></p>
<p class="hang"><span>2 carrots, sliced</span></p>
<p class="hang"><span>1 cup sliced green onions</span></p>
<p class="hang"><span>1 package (10 ounces) each: frozen chopped broccoli, cauliflower</span></p>
<p class="hang"><span>1½ cups reduced-sodium fat-free chicken broth</span></p>
<p class="hang"><span>3 cups fat-free milk, divided</span></p>
<p class="hang"><span>1 tablespoon cornstarch</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Sauté carrots and green onions in lightly greased large saucepan until lightly browned, about 8 minutes. Add broccoli, cauliflower, and chicken broth; heat to boiling. Reduce heat and simmer, covered, until vegetables are tender, about 5 minutes. Process half the vegetable mixture in food processor or blender until smooth; return to saucepan and heat to boiling. Stir in combined ½ cup milk and cornstarch, stirring until thickened, about 1 minute. Stir in remaining 2½ cups milk; cook, covered, over medium heat until hot, about 5 minutes. Season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 75</span></p>
<p class="per1"><span>% calories from fat: 4</span></p>
<p class="per1"><span>Protein (g): 6.3</span></p>
<p class="per1"><span>Carbohydrate (g): 12.6</span></p>
<p class="per1"><span>Fat (g): 0.4</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 1.7</span></p>
<p class="per1"><span>Sodium (mg): 104</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 3.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0210.vue?5133944a